/**
 * User-facing copy for incremental enrichment review saves.
 */

export function enrichmentReviewSaveStatusMessage(pendingCount, { descriptionInFlight = false } = {}) {
  const n = Math.max(0, Number(pendingCount) || 0);
  if (n <= 0 && !descriptionInFlight) return "";
  const total = n + (descriptionInFlight && n === 0 ? 1 : 0);
  if (total <= 0) return "";

  if (descriptionInFlight && total === 1) {
    return "Saving the app description…";
  }
  if (total === 1) {
    return "Adding to your map in the background… You can leave anytime.";
  }
  return `Adding ${total} items to your map in the background… You can leave anytime.`;
}

export const ENRICHMENT_DESCRIPTION_SAVE_HINT =
  "Updates the app description on your map when you approve.";
